import React from 'react';
import { AskVantageProvider } from '../context/AskVantageProvider';
import { TTSProvider } from '../context/TTSProvider';
import AskVantageContainer from '../components/Container';

const AskVantageApp: React.FC = () => {
  return (
    <AskVantageProvider>
      <TTSProvider>
        <AskVantageContainer />
      </TTSProvider>
    </AskVantageProvider>
  );
};

export default AskVantageApp;
